var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from "react";
import PropTypes from "prop-types";
import MeasureComponent from "react-measure";
import { withProvider, consumeContext } from "./AppContext";
import VideoPreview from "./Containers/VideoPreview";
import UiOverlay from "./Containers/UiOverlay";
import Toolbar from "./Containers/Toolbar";
import ScriptEditor from "./Containers/ScriptEditor";
import ProcessingModal from "../Misc/ProcessingModal";

function Measure(_ref) {
  var _onResize = _ref.onResize;
  return React.createElement(MeasureComponent, {
    bounds: true,
    onResize: function onResize(_ref2) {
      var bounds = _ref2.bounds;

      _onResize(bounds);
    }
  }, function (_ref3) {
    var measureRef = _ref3.measureRef;
    return React.createElement("div", {
      className: "video-measure",
      style: {
        width: "100%",
        height: "100%"
      },
      ref: measureRef
    });
  });
}

var VideoRecorder = (_temp = _class = function (_Component) {
  _inherits(VideoRecorder, _Component);

  function VideoRecorder() {
    _classCallCheck(this, VideoRecorder);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  VideoRecorder.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        AppContext = _props.AppContext,
        onVideoReady = _props.onVideoReady,
        onClose = _props.onClose,
        framesSource = _props.framesSource,
        rest = _objectWithoutProperties(_props, ["AppContext", "onVideoReady", "onClose", "framesSource"]);

    AppContext.initializeState(_extends({}, rest, {
      frames: {
        framesSource: framesSource
      }
    }));
    AppContext.setVideoReadyHandler(onVideoReady);
    AppContext.setCloseHandler(onClose);
  };

  VideoRecorder.prototype.render = function render() {
    var _this2 = this;

    var recordedVideo = this.props.AppContext.state.recordedVideo;
    return React.createElement("div", {
      className: "recorder recorder--style-preview"
    }, React.createElement(Measure, {
      onResize: function onResize(_ref4) {
        var width = _ref4.width,
            height = _ref4.height;

        _this2.props.AppContext.setOrientation(width >= height ? "landscape" : "portrait");
      }
    }), React.createElement(VideoPreview, null), !recordedVideo && React.createElement(UiOverlay, null), React.createElement(Toolbar, null), React.createElement(ScriptEditor, null), React.createElement(ProcessingModal, {
      title: "Processing video",
      text: "Please wait few seconds until finished.",
      active: this.props.AppContext.state.isProcessing
    }));
  };

  return VideoRecorder;
}(Component), _class.defaultProps = {
  autoStopTimeout: 0,
  videoMimeType: "video/webm"
}, _temp);
VideoRecorder.propTypes = process.env.NODE_ENV !== "production" ? {
  script: PropTypes.shape({
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    formatter: PropTypes.func
  }),
  mobileRecordSettings: PropTypes.shape({
    sendLink: PropTypes.func.isRequired,
    knownNumbers: PropTypes.array
  }),
  onVideoReady: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onScriptTextChange: PropTypes.func,
  AppContext: PropTypes.object.isRequired,
  startTimeout: PropTypes.number,
  autoStopTimeout: PropTypes.number,
  videoMimeType: PropTypes.string,
  qrCodeData: PropTypes.func,
  framesSource: PropTypes.func,
  onFrameChange: PropTypes.func,
  filterFramesToCurrentResolution: PropTypes.bool,
  assistScriptGeneration: PropTypes.func
} : {};
export default withProvider(consumeContext(VideoRecorder));